import React from 'react';

export default function () {
  return (
    <div>
      <style>{'html, body { height: 100%; }'}</style>
      <div className="maintenance-bg"></div>

      <div className="maintenance-wrapper">

        <div className="maintenance">

          <div className="maintenance-icon">
            <i className="fa fa-cog fa-spin gear-1"></i>
            <i className="fa fa-cog fa-spin gear-2 text-primary"></i>
            <i className="fa fa-cog fa-spin gear-3 text-secondary"></i>
          </div>

          <h1 className="maintenance-title">We're performing an upgrade to GCM</h1>

          <p className="maintenance-description">
            We don't plan it taking long, but sometimes we forget to feed the code monkeys their bananas.
          </p>

          <hr />

          <p className="maintenance-contact">
            <a href="tel:2025587717">(202) 558-7717</a>
            <a href="mailto:info@greekcapitalmanagement.com">info@greekcapitalmanagement.com</a>
          </p>
        </div>

      </div>
    </div>
  );
}
